import { render, staticRenderFns } from "./VideoMain.vue?vue&type=template&id=d20f0e44&scoped=true&"
import script from "./VideoMain.vue?vue&type=script&lang=js&"
export * from "./VideoMain.vue?vue&type=script&lang=js&"
import style0 from "./VideoMain.vue?vue&type=style&index=0&id=d20f0e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20f0e44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d20f0e44')) {
      api.createRecord('d20f0e44', component.options)
    } else {
      api.reload('d20f0e44', component.options)
    }
    module.hot.accept("./VideoMain.vue?vue&type=template&id=d20f0e44&scoped=true&", function () {
      api.rerender('d20f0e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/Video/VideoMain.vue"
export default component.exports